import React from 'react'
import Box from '../components/Box'

import img1 from '../assets/images/target023.png';
import img2 from '../assets/images/target024.webp';

export default function Section11() {
    return (
        <div className="section">
            <h2>Section XI: iTunes File Sharing</h2>
            <div className="box-container">
                <div className="heading">Section XI: iTunes File Sharing</div>
                <div className="body">
                    <p>Tunes File Sharing allows copying files to and from the documents directory on the iOS Device. Follow these steps to use this feature:</p>
                    <p>1. Connect the iOS Device via USB.</p>
                    <p>2. Open iTunes</p>
                    <p>3. Select the iOS Device from the list of devices.</p>
                    <img src={img1} alt="select device" />
                    <p>4. Select the "Apps" tab.</p>
                    <p>5.Scroll down to the “File Sharing” section and select “GradeBook Pro”.</p>
                    <img src={img2} alt="file sharing" />
                </div>
            </div>
            <Box title={'Send a File to the iOS Device'} body={`This function will copy a file from your local hard drive to the documents directory on the iOS Device.
Use this to replace a database file with an archived version or to add a .csv, .gbr, or .gbs file for
importing.
Note: If you use this feature to restore a database file you must reboot the iOS Device to force
GradeBook Pro to reload the database. Reboot by holding the home and power buttons until the
Apple logo appears.
1. Click “Add”.
2. Select the file to upload.
3. Click “Choose”.
a. If you are replacing a file with the same name you must confirm the overwrite operation.`} />

            <Box title={'Get a File from the iOS Device'} body={`This function will retrieve a file from the documents directory on the iOS Device. Use this to retrieve
your database file (for archiving or troubleshooting) or a generated report.
1. Click the file to retrieve from the documents list.
2. Click “Save to...”.
3. Select the location to store the file.`} />
        </div>
    )
}
